module.exports = __webpack_public_path__ + "89ada58871683e053b0807b62490c01c.svg";